<template>
  <section class="c_event_card" :class="cardStyle" ref="c_event_card">
    <div class="c_2022--body c_event_card__type" v-if="eventType">{{ eventType }}</div>
    <div class="c_event_card__content">
      <span class="c_event_card__eyebrow" v-if="eyebrowText">{{ eyebrowText }}</span>
      <h3 class="c_2022--h2_graphik" v-if="eventTitle">{{ eventTitle }}</h3>
      <MediaImage :sources="eventImage" :alt="eventTitle" v-if="eventImage && eventImage[0] !== undefined" />
      <div class="c_2022--body c_event_card__description" v-html="eventDescription" v-if="eventDescription"></div>
      <div class="c_event_card__buttons" v-if="hasButtons">
        <Button
          v-for="(button, index) in buttons"
          :key="index"
          class="c_button_2022"
          :class="button.class"
          :href="getHrefs(button)"
          :target="newWindow(button)"
        >
          {{ button.text }}
        </Button>
      </div>
    </div>
  </section>
</template>

<script>
import MediaImage from 'Components/image/MediaImage.vue';
import Button from 'Components/button/Button.vue';
import { openPdfsInNewTab } from 'JS/global.js';
export default {
  props: {
    eventType: String,
    eyebrowText: String,
    eventTitle: String,
    eventImage: Array,
    eventDescription: String,
    cardStyle: String,
    primaryButton: Object,
    secondaryButton: Object,
  },
  data() {
    return {
      formattedEvent: [],
    };
  },
  components: {
    MediaImage,
    Button,
  },
  computed: {
    // Determine if there is at least one button
    hasButtons() {
      return this.primaryButton.primaryButtonText || this.secondaryButton.secondaryButtonText;
    },
    buttons() {
      const buttons = [];
      if (this.primaryButton.primaryButtonText) {
        buttons.push({
          class: 'c_button_2022__primary',
          text: this.primaryButton.primaryButtonText,
          ...this.primaryButton,
        });
      }
      if (this.secondaryButton.secondaryButtonText) {
        buttons.push({
          class: 'c_button_2022--text_black c_button_2022__secondary',
          text: this.secondaryButton.secondaryButtonText,
          ...this.secondaryButton,
        });
      }
      return buttons;
    },
  },
  methods: {
    getHrefs(btn) {
      const isPrimary = btn.primaryButtonText;

      // Get button data based on primary or secondary button
      const buttonData = isPrimary
        ? {
            customUrl: btn.primaryButtonCustomUrl,
            entry: btn.primaryButtonEntry,
            asset: btn.primaryButtonAsset,
          }
        : {
            customUrl: btn.secondaryButtonCustomUrl,
            entry: btn.secondaryButtonEntry,
            asset: btn.secondaryButtonAsset,
          };

      // Return URL of entry or asset
      if (!buttonData.customUrl?.length) {
        return buttonData.entry?.length ? this.localePath(`/${buttonData.entry[0]?.uri}`) : buttonData.asset[0]?.url;
      }

      // Otherwise return custom URL, or null if no value exists
      return buttonData.customUrl || null;
    },
    newWindow(btn) {
      const hasCustomUrl = btn.primaryButtonCustomUrl || btn.secondaryButtonCustomUrl;
      const hasPdf =
        (btn.primaryButtonAsset || btn.secondaryButtonAsset)?.kind === 'pdf' || this.getHrefs(btn).includes('.pdf');

      return hasCustomUrl || hasPdf ? '_blank' : null;
    },
  },
  mounted() {
    openPdfsInNewTab(this.$refs.c_event_card);
  },
};
</script>

<style lang="scss">
.c_event_card {
  $self: &;

  border-bottom-left-radius: px_to_rem(15);
  border-bottom-right-radius: px_to_rem(15);
  margin-bottom: px_to_rem(40);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 px_to_rem(15) px_to_rem(32) px_to_rem(15);
  @include mq($mq_sm_to_md) {
    padding: 0 px_to_rem(32) px_to_rem(40) px_to_rem(32);
  }
  @include mq($mq_md_to_lg) {
    margin-bottom: 0;
  }
  @at-root #{$self}__type {
    display: inline-block;
    @include font('graphik_semibold');
    border-bottom-left-radius: px_to_rem(15);
    border-bottom-right-radius: px_to_rem(15);
    margin-bottom: px_to_rem(32);
    padding: px_to_rem(13) px_to_rem(15);
    @include mq($mq_sm_to_md) {
      padding: px_to_rem(18) px_to_rem(32);
    }
    @include mq($mq_md_to_lg) {
      margin-bottom: px_to_rem(55);
    }
  }
  @at-root #{$self}__content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-grow: 1;
    @at-root #{$self}__eyebrow {
      @include font('graphik_medium');
    }
    h3 {
      @include font('graphik_extralight');
      margin-bottom: px_to_rem(25);
    }
    @at-root #{$self}__description {
      margin-top: px_to_rem(25);
      @include font('graphik_regular');
      p {
        margin-bottom: px_to_rem(25);
      }
      em {
        @include font('graphik_regular_italic');
      }
      strong {
        @include font('graphik_semibold');
      }
    }
  }
  @at-root #{&}--white {
    $c_white: &;
    background-color: $color_white;
    border: 1px solid $color_gray_112;
    .c_event_card__type {
      color: $color_white;
      background-color: $color_red;
    }
  }
  @at-root #{&}--yellow {
    $c_white: &;
    background-color: $color_yellow;
    border: 1px solid $color_yellow;
    .c_event_card__type {
      color: $color_white;
      background-color: $color_black;
    }
  }
  .c_button_2022__primary {
    margin-right: px_to_rem(10);
    @include mq($mq_md_to_lg) {
      margin-right: px_to_rem(20);
      margin-bottom: px_to_rem(20);
    }
  }
  @at-root #{&}__buttons {
    margin-top: auto;
  }
}
</style>
